import { GenericModal } from "views/mobile/components/GenericModal";
import { Spacer } from "../common/Spacer";
import { WizzardButton } from "../WizzardButton";
import { Wrapper } from "./styles";
import { dateToString } from "lib/date";
import { pathOr } from "ramda";
import { selectOffice } from "state/offices/selectors";
import { useCancelReservation } from "state/reservations/hooks";
import { useDispatch, useGlobal } from "reactn";
import { useHistory } from "react-router";
import React, { useState } from "react";

export const ExistingReservationWrapper = ({
	onClick,
	desktop,
	reservation,
	isLoggedInTemporary,
}) => {
	const history = useHistory();
	const [showModal, setShowModal] = useState(false);
	const stringDate = reservation && dateToString(reservation.from);
	const reservationId = pathOr(null, ["_id"], reservation);
	const officeSlug = pathOr(null, ["office"], reservation);
	const lineSlug = pathOr(null, ["line"], reservation);
	const [cancelReservation, cancelLoading] = useCancelReservation(
		reservationId,
		reservation.isV2,
		isLoggedInTemporary,
		officeSlug
	);
	const [offices] = useGlobal("officesv2");
	const office = selectOffice(offices, officeSlug);
	const handleSetOldIdReservation = useDispatch("handleSetOldIdReservation");
	const allowOldIdReservation = pathOr(
		false,
		["options", "allowOldIdReservations"],
		office
	);
	const isAllowRervationsV3 = pathOr(
		false,
		["options", "isAllowRervationsV3"],
		office
	);

	const goToReservationScreen = () => {
		history.push(`/reserve/${officeSlug}/${lineSlug}/${reservationId}`);
	};

	const goToRereservationScreen = () => {
		handleSetOldIdReservation(reservationId);
		history.push(`/offices/${officeSlug}/${lineSlug}/reservation`);
	};

	return (
		<Wrapper desktop={desktop}>
			<div className={"info-text-container"}>
				{!desktop && <Spacer rows={0.4} />}
				<div>Tienes una reserva para el</div>
				<Spacer rows={0.2} />
				<div className="date">{stringDate}</div>
				{!desktop && <Spacer rows={1} />}
			</div>

			<div className={"info-buttons-container"}>
				{!desktop && (
					<WizzardButton
						type="primary"
						label={"Ver reserva"}
						size={desktop ? "160px" : "180px"}
						onClick={goToReservationScreen}
					/>
				)}

				<WizzardButton
					type="cancelReservation"
					label={"Cancelar reserva"}
					size={desktop ? "160px" : "180px"}
					onClick={() => setShowModal(true)}
				/>
				{!desktop && <Spacer rows={0.4} />}
				{desktop && !allowOldIdReservation ? (
					<WizzardButton
						type="primary"
						label={"Ver reserva"}
						size={desktop ? "160px" : "180px"}
						onClick={goToReservationScreen}
					/>
				) : (
					isAllowRervationsV3 && (
						<WizzardButton
							type="primary"
							label={"Reagendar reserva"}
							size={desktop ? "160px" : "180px"}
							onClick={goToRereservationScreen}
						/>
					)
				)}
			</div>
			<GenericModal
				visible={showModal}
				type={"reservationCancel"}
				onClick={cancelReservation}
				loading={cancelLoading}
				onCancel={() => setShowModal(false)}
			/>
		</Wrapper>
	);
};
